export enum Permission {
  Checkout = 'checkout.modify',
  AdminPanel = 'admin_panel.legacy_permission',
}
